/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { createContext } from 'use-context-selector';
import { node } from 'prop-types';

import { analyticsService } from 'Utils/analytics/analyticsService';
import useUser from 'Hooks/useUser';

export const AnalyticsContext = createContext(analyticsService);

const AnalyticsProvider = ({ children }) => {
  const { data: user } = useUser();

  useEffect(() => {
    analyticsService.init();
  }, []);

    useEffect(() => {
    if (user?.userId) {
      analyticsService.identify(user?.userId, user?.isImpersonated);
    }
  }, [user?.userId, user?.isImpersonated]);

  return (
    <AnalyticsContext.Provider value={ analyticsService }>
      {children}
    </AnalyticsContext.Provider>
  );
};

AnalyticsProvider.propTypes = {
  children: node.isRequired,
};

AnalyticsProvider.displayName = 'AnalyticsProvider';

export default AnalyticsProvider;
